import { EVENTS_CLOSE_ACTION_FORM_MODAL } from './constants';

export function closeActionFormModal() {
  return {
    type: EVENTS_CLOSE_ACTION_FORM_MODAL,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_CLOSE_ACTION_FORM_MODAL:
      return {
        ...state,
        isOpenActionPropModal: false,
      };

    default:
      return state;
  }
}
